export default defineNuxtPlugin(() => {
    console.warn = () => { };
})
